/**
 * Initialize Tealium analytics script
 */
export const initTealium = () => {

	return new Promise((resolve) =>
		setTimeout(() => {
			return resolve()
		}, 100)
	)
}

/**
 * Send event data to Tealium
 * @param {string} eventName Name of event to track
 * @param {object} data Key value pairs of data being tracked
 */
export const tealiumTrack = (ename,tname,obj,cacheAttempt) => {
	// todo: remove, just for developing
	console.log('Tealium eventName: ' + ename)
	console.log('Tealium type: ' + tname)
	const isStandalone = window.self === window.top
	let currentUtag = window.utag_iframe
	if (isStandalone) currentUtag = window.utag
	
	try {
		if (window && currentUtag) {
			if (ename == 'core-etfs:authenticated') {
				//window['globalAnalyticsParams'].loggedIn = 'yes';
				//window['globalAnalyticsParams'].padlockedContent = 'yes';
				//['globalAnalyticsParams'].webTrackingId = obj.id;

				//window['adobe_logged_in'] = "true";
				//window['adobe_registration_submitted'] = "true";

			} else {
				if (tname=='view') {
					currentUtag.view({view_name:ename})
				} else {
					currentUtag.link({link_name:ename})
				}

			}
		} else if (cacheAttempt < 10) {
			// I am not seeing it ever get in here, but my local is weird with utag, so it might on dev. This will try again in case it's not loaded
			// todo: remove, just for developing
			console.log('Utag not loaded yet, trying again')

			if (!cacheAttempt) cacheAttempt = 0
			setTimeout(() => {
				tealiumTrack(ename,tname,obj,cacheAttempt+1)
			},1000)
		}

	} catch (e) {
		console.log(e);
	}
}